import type { Theme } from '@mui/material/styles';

// The one keyboard-focus ring of interactive chrome: offset so it never merges with a fill or border.
export const focusRing = (theme: Theme) =>
  ({
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: theme.palette.primary.main,
    outlineOffset: '2px',
  }) as const;

// Navigation: the current entry must not read as hovered, so it takes the stronger tint.
export const NAV_HOVER_ALPHA = 0.08;
export const NAV_CURRENT_ALPHA = 0.12;
// The interactive pill's hover and open wash, in ink: a hint, not a fill.
export const PILL_ACTIVE_ALPHA = 0.04;
